import React from 'react';
import { SectionCTA } from '../SectionCTA';
import { AUTHOR_IMAGE } from '../../data/links';
export function Author() {
  return <section className="bg-canvas px-5 py-14 md:py-20" data-id="element-75" data-mp="1htc411tlj5e3">
      <div className="mx-auto grid max-w-5xl items-center gap-8 md:grid-cols-[2fr_3fr] md:gap-12" data-id="element-76" data-mp="1wh6xikffhds8">
        <div className="relative mx-auto w-full max-w-sm" data-id="element-77" data-mp="1rpf5s6kjd20i">
          <img src={AUTHOR_IMAGE} alt="Rachel Bennett, author" className="aspect-square w-full rounded-3xl object-cover shadow-lg" data-id="element-78" data-mp="1rnvnkafbkgw3" />
          <div className="absolute -bottom-4 left-4 right-4 rounded-2xl bg-navy px-4 py-3 text-center text-white shadow-lg" data-id="element-79" data-mp="20iioata1g520">
            <p className="text-lg font-extrabold leading-tight" data-id="element-80" data-mp="2fehxy8csqd99">Rachel Bennett</p>
            <p className="text-xs text-gold" data-id="element-81" data-mp="2afwxq8xjntkt">Surgical Nursing &amp; Critical Care Educational Resources</p>
          </div>
        </div>

        <div className="pt-4 md:pt-0" data-id="element-82" data-mp="l21s38nwx14x">
          <p className="text-center text-xs font-extrabold uppercase tracking-[0.14em] text-teal md:text-left" data-id="element-83" data-mp="g2f5w9q3wajz">Meet Your Author</p>
          <h2 className="mt-2 text-center text-[26px] font-extrabold leading-[1.18] text-navy md:text-left md:text-4xl" data-id="element-84" data-mp="3gf5pc4pfa6de">
            Practical Clinical Workflows Designed for Real Healthcare Environments
          </h2>
          <div className="mt-5 space-y-4 text-[16px] leading-relaxed text-navy/75" data-id="element-85" data-mp="3pe997aweypsy">
            <p data-id="element-86" data-mp="3u6svqxd2wv9w">
              Rachel Bennett is the author behind a collection of professional nursing resources focused on clinical
              assessment, structured documentation, and organized decision-support workflows.
            </p>
            <p data-id="element-87" data-mp="80nl6e2lraz2">
              Her educational materials emphasize practical tools that help qualified healthcare professionals organize
              clinical information, communicate relevant findings, and support continuity of care.
            </p>
            <p data-id="element-88" data-mp="2dsar01di9j34">
              Rather than overwhelming professionals with unnecessary theory, the blueprint focuses on structured
              assessment pathways, documentation templates, warning-sign reference tools, and communication frameworks.
            </p>
          </div>
          <blockquote className="mt-6 border-l-4 border-gold pl-4 text-[17px] font-semibold italic leading-relaxed text-navy" data-id="element-89" data-mp="3h2yfsmxhfvxx">
            “Clear observations, structured documentation, and effective communication are essential components of
            professional patient care.”
          </blockquote>
        </div>
      </div>
      <div className="mx-auto max-w-3xl" data-id="element-90" data-mp="8tosb003e3m5">
        <SectionCTA label="Get Rachel's Toolkit" data-id="element-91" data-mp="8sn5jy9prsol" />
      </div>
    </section>;
}